import { usePageMeta } from "@/hooks/usePageMeta";
import { videos } from "@/mocks/videos";
import BannerCarousel from "@/pages/home/components/BannerCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import LatestGrid from "@/pages/home/components/LatestGrid";
import FeaturedTracks from "@/pages/home/components/FeaturedTracks";

export default function Home() {
  usePageMeta(
    "芒果视频-热门影视剧在线观看与精彩视频推荐",
    "芒果视频为您提供最新最热影视剧集、综艺节目及短视频内容，涵盖多种类型，满足不同用户的观看需求。畅享精彩视频资源，发现更多影视精彩。",
    "芒果视频,影视视频,电视剧,电影,综艺节目,视频推荐,在线观看,影视资源"
  );

  const stats = [
    { label: "精选内容", value: videos.length, icon: "ri-video-line" },
    { label: "内容分类", value: 4, icon: "ri-apps-2-line" },
    { label: "覆盖地区", value: 4, icon: "ri-earth-line" },
    { label: "持续更新", value: "每日", icon: "ri-refresh-line" },
  ];

  return (
    <>
      <BannerCarousel />

      <section className="border-b border-background-200/70 bg-background-100/60">
        <div className="mx-auto grid w-full max-w-[1440px] grid-cols-2 gap-4 px-4 py-6 md:grid-cols-4 md:px-6 lg:px-10">
          {stats.map((stat) => (
            <div key={stat.label} className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500/15 text-primary-400">
                <i className={`${stat.icon} text-xl`}></i>
              </span>
              <div>
                <p className="font-label text-lg font-bold text-foreground-950">{stat.value}</p>
                <p className="text-xs text-foreground-600">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <CategoryEntries />
      <LatestGrid />
      <FeaturedTracks />
    </>
  );
}